import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import * as Actions from './actions'
import { callApi } from '../../../utils/callApi'
import { API_ROUTES } from '../../../utils/apiRoutes'
import { ActionTypes, TRoles } from './types'


function* getRolesWorker(action: ReturnType<typeof Actions.GetRoles.request>) {
  const { callBack } = action.payload as Actions.TypeGetRolesR
  let success = true
  let data = null
  
  try {
    data = (yield call(callApi, {
      method: 'get',
      path: API_ROUTES.roles,
    })) as TRoles[]
    
    yield put(Actions.GetRoles.success(data))
  } catch (e) {
    success = false
    // @ts-ignore
    data = e?.data || e
    yield put(Actions.GetRoles.error(`${data?.message || data}`))
  } finally {
    if (callBack) callBack(success, data)
  }
}


function* watchRequest() {
  yield takeEvery(ActionTypes.GET_ROLES_R, getRolesWorker)
}

export default function* rolesSaga() {
  yield all([fork(watchRequest)])
}
